'use client'

import { Button, Divider, Dialog, Navigation } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import EditCountryUinForm from '../EditCountryUinForm'

type Props = {
  show: boolean
  onClose: () => void
  category: string
  uin: string
  uinId: number
  refetch: () => void
}

const EditCountryUinModal = ({ show, onClose, category, uin, uinId, refetch }: Props) => {
  const renderNavigation = () => {
    return (
      <Navigation
        body={category}
        right={
          <Button
            inline
            iconName={X24}
            styling="flat"
            onClick={onClose}
            testId="address-modal-navigation-close-button"
          />
        }
      />
    )
  }

  return (
    <Dialog show={show} testId="edit-uin-modal" title={category} closeOnOverlay>
      {renderNavigation()}
      <Divider />
      <EditCountryUinForm uinId={uinId} uinNumber={uin} onClose={onClose} refetch={refetch} />
    </Dialog>
  )
}

export default EditCountryUinModal
